import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_FOODS,
  FLAG_GETTING_FOODS,
  GET_FOODS,
} from '../../../actions/types/food/Food';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_FOODS:
      return state.setIn(['all', 'loading'], payload);
    case GET_FOODS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_FOODS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
